var periodicRefresh = function() {

    var timeout = 900000,
        fields = document.querySelectorAll('input,textarea,select,radio'),
        fieldFocus = false;

    var _init = function () {

		if (document.querySelector('[data-periodic-refresh-blocking-element]')) {
			// Video's have this attribute.
			return;
		}

        if(fields !== null){

            [].map.call(fields, function(field){
                field.addEventListener('focus', function () {
                    fieldFocus = true;
                });
                field.addEventListener('blur', function () {
                    fieldFocus = false;
                });
            });

        }

        schedulePeriodicRefresh();

    };

    var schedulePeriodicRefresh = function () {

        setTimeout(function () {

            if (fieldFocus === false) {
                location.reload();
            }

        }, timeout);

    };

    return {
        init: _init
    }

}();

periodicRefresh.init();
